// @ts-nocheck

export const localeCodes =  [
  "nl"
]
export const localeLoaders = {
  nl: [
    {
      key: "locale_nl_46json_87d8bcea",
      load: () => import("#nuxt-i18n/87d8bcea" /* webpackChunkName: "locale_nl_46json_87d8bcea" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "nl",
    iso: "nl-NL",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

